import { Table } from "react-bootstrap";
import styled from "styled-components";

export const CustomTable = styled(Table)`
  margin-top: 32px;
  border-radius: 8px;
  
  .table-header {
    background-color: ${({ theme }) => theme.colors.secundary};
    color: ${({ theme }) => theme.colors.shape};
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 700;
    border: none;
  }

  .table-body td {
    padding: 30px 10px;
  }

  .table-body {
    border-top: none !important;
  }

  .table-body tr:nth-of-type(odd) {
  background-color: rgba(14, 134, 254, 0.05);
}
`;